import React, { FC } from 'react';
import { ASSETS_PATH } from '@app/react/const/variables';

export const SakuraIcon: FC = () => (
    <img
        className="sakura"
        src={`${ASSETS_PATH}/brandsite/select_guide__img-1.svg`}
        alt="桜"
    />
);
